import { Component } from 'opus-angular-seed-core';
import { stripTrailingEmptyParagraphs } from '../../../../../services/htmlContent';

@Component({
    bindings: {
        uibModalInstance: '=',
        trainingForm: '=',
        company: '=',
        course: '=',
        context: '=',
        viewMode: '='
    },
    template: `
<div class="material-editor-02" id="editor-wrapper">
    <div class="click-outside-overlay"
        ng-if="this.clickOutsideOverlayDislayed"
        ng-click="this.clickOutsideOverlayDislayed = false; vm.closeAllSections()">
    </div>
	<div class="modal-header" ng-if="vm.viewMode === 'editor'">
		<div class="heading01">
			<h2 style="font-size:20px;">{{ 'general.Manage content' | translate }}</h2>
			<ul class="actions01">
				<li class="primary ml20">
                    <button
                        ng-disabled="vm.editorLoading"tinymce.init
                        ng-click="vm.closeModal()"
                        target="_blank"
                        class="btn bordered02 ico-close02">
                            {{ 'general.Close' | translate }}
                     </button>
                </li>
				<li class="primary">
                    <button
                        ng-disabled="vm.editorLoading || !vm.models[vm.materialIndex].list.length"
                        ng-class="{'loading':vm.editorLoading}"
                        ng-click="vm.save()"
                        class="btn main"
                        type="button">
                            {{ 'general.Save' | translate }}
                    </button>
                </li>
				<li class="primary">
                    <button
                        ng-disabled="vm.editorLoading"
                        ng-click="vm.toggleSettings()"
                        class="btn bordered02 ico-settings02 material-editor-02__settings-toggle"
                        type="button">
                            {{ 'authoringTool.General settings' | translate }}
                    </button>
                </li>
				<li class="primary">
                    <button
                        ng-disabled="vm.editorLoading || vm.previewLoading || !vm.models[vm.materialIndex].list.length"
                        ng-class="{'loading':vm.previewLoading}"
                        style="font-weight: 600"
                        ng-click="vm.initMode('preview')"
                        class="authoring-tool-white-button btn bordered02">
                            {{ 'courses.Preview' | translate }}
                    </button>
                </li>
            </ul>
		</div>
	</div>
	<div class="modal-body">
        <div ng-if="vm.viewMode === 'preview' && !vm.previewLoading" class="material-preview">
            <courses-authoring-tool-view
                view-only="true"
                is-admin-preview="true"
                material="vm.previewMaterial"
                view-mode="vm.viewMode"
                company="vm.company"
                preview-loading="vm.previewLoading"
                course="vm.course"
                init-mode="vm.initMode"
                on-close-modal="vm.closeModal"
                is-editor-view-generated="vm.isEditorViewGenerated"
            />
        </div>
		<div ng-if="vm.viewMode === 'editor'" class="material-editor" ng-if="vm.isEditorViewGenerated">
			<nav class="material-editor-02__nav" id="editor-nav">
				<div class="material-editor-02__nav-inner">
                    <div class="material-editor__languages">
                        <select class="form-control" style="padding:9px" ng-model="vm.selectedLanguage" ng-change="vm.changeLanguage()">
                            <option ng-repeat="(index, material) in vm.trainingForm.materials" value="{{ material.lang }}">
                                {{ vm.models[index].isEnabled ? '🟢' : '🔴' }} {{ vm.COMPANY_LANGUAGE_ENUM.LABELS[material.lang] }}
                            </option>
                        </select>
                        <label class="switch02">
                            <input type="checkbox" ng-checked="vm.isLanguageEnabled(vm.selectedLanguage)"
                                ng-click="vm.toggleLanguage(vm.selectedLanguage)">
                            <span>{{ 'course.materialSource.Language enabled' | translate }}</span>
                        </label>
                    </div>
                    <ul ng-if="vm.models[vm.materialIndex].list.length"
                        dnd-list="vm.models[vm.materialIndex].list"
                        class="material-editor-02__toc"
                    >
						<li ng-repeat="item in vm.models[vm.materialIndex].list"
							dnd-draggable="item"
       dnd-moved="vm.onChapterMoved(vm.models[vm.materialIndex].list, $index)"
							dnd-effect-allowed="move"
							dnd-disable-if="vm.edit"
							dnd-type="item.type"
							class="material-editor-02__toc-item"
							ng-class="{'section': item.type==='section',
								'chapter': item.type==='chapter',
								'active': vm.models[vm.materialIndex].selected === item,
								'hidden-chapter': item.type==='chapter' && item.isVisible === false}"
						>
							<div ng-click="vm.setChapter(item)" class="material-editor-02__toc-item-heading" ng-if="item.type==='chapter'">
                            <!-- CHAPTER -->
								<a style="width:100%" class="material-editor-02__toc-item-title"
                                    ng-if="!item.edit || item.edit !== true"
                                    ng-class="{'active': vm.models[vm.materialIndex].selected === item,
                                        'error': item.status === 'error', 'muted': item.isVisible === false}">
									{{ item.name }}
									<span class="material-editor-02__toc-item-meta" ng-if="item.description">{{item.description}}</span>
								</a>
								<input ng-model="item.name" type="text" ng-if="item.edit === true" class="form-control menu-item-edit-input" value="{{item.name}}"/>
								<button class="btn ico-check success" ng-if="item.edit === true" ng-click="item.edit=false; vm.edit=false;"/>
								<div class="material-editor-02__action-menu action-menu" ng-if="!item.edit || item.edit !== true">
									<button aria-haspopup="true" aria-expanded="{{item.actions}}" ng-click="vm.actions=false;vm.closeMenus(item); vm.showItemMenu($event); item.actions=!item.actions;">
                                        <span>&nbsp;</span>
                                    </button>
									<ul role="action-menu">
										<li><a ng-click="vm.actions=false;vm.closeMenus(); item.edit=true; vm.edit=true">{{ 'general.Edit' | translate }}</a></li>
										<li><a ng-click="vm.toggleChapterVisibility(item)">
											{{ item.isVisible === false
												? ('authoringTool.Show chapter' | translate)
												: ('authoringTool.Hide chapter' | translate) }}
										</a></li>
										<li><a ng-click="vm.setChapterVisibilityInAllLanguages(item, true)">
											{{ 'authoringTool.Make this chapter visible in all languages' | translate }}
										</a></li>
										<li><a ng-click="vm.setChapterVisibilityInAllLanguages(item, false)">
											{{ 'authoringTool.Hide this chapter in all languages' | translate }}
										</a></li>
										<li><a ng-click="vm.exportChapter(item)">
											{{ 'authoringTool.Export to another language' | translate }}
										</a></li>
										<li><a ng-click="vm.deleteChapter(item)">{{ 'general.Delete' | translate }}</a></li>
									</ul>
								</div>
							</div>
                            <!-- SECTION -->
							<div class="material-editor-02__toc-item-heading" ng-if="item.type==='section'">
								<a class="material-editor-02__toc-item-title"
                                    ng-if="!item.edit || item.edit !== true" ng-class="{'active': vm.models[vm.materialIndex].selected === item, 'error': item.status === 'error'}">
                                    {{item.name}}
                                </a>
								<input type="text" ng-model="item.name" ng-if="item.edit === true" class="form-control menu-item-edit-input" value="{{item.name}}"/>

								<button class="btn ico-check success" ng-if="item.edit === true" ng-click="item.edit=false; vm.edit=false;"/>
								<div class="material-editor-02__action-menu action-menu" ng-if="!item.edit || item.edit !== true">
									<button aria-haspopup="true" aria-expanded="{{item.actions}}"
                                        ng-click="vm.actions=false;vm.closeMenus(item); item.actions=!item.actions; vm.showItemMenu($event);"><span>&nbsp;</span></button>
									<ul role="action-menu">
										<li><a ng-click="item.edit=true; vm.edit=true">{{ 'general.Edit' | translate }}</a></li>
										<li><a ng-click="vm.deleteSection(item)">{{ 'general.Delete' | translate }}</a></li>
                                        <li><a ng-click="vm.addChapterToSection(item);item.actions = !item.actions">{{ 'authoringTool.Add chapter' | translate }}</a></li>
										<li><a ng-click="vm.setSectionChaptersVisibility(item, true)">
											{{ 'authoringTool.Show all chapters in this section' | translate }}
										</a></li>
										<li><a ng-click="vm.setSectionChaptersVisibility(item, false)">
											{{ 'authoringTool.Hide all chapters in this section' | translate }}
										</a></li>
									</ul>
								</div>
							</div>

							<ul dnd-list="item.items"
								class="material-editor-02__toc-subitems"
                                dnd-allowed-types="item.allowedTypes"
								ng-if="item.type==='section'">
								<li ng-repeat="subitem in item.items" dnd-draggable="subitem" class="material-editor-02__toc-subitem chapter"
         dnd-moved="vm.onChapterMoved(item.items, $index)"
									dnd-effect-allowed="move"
									dnd-disable-if="vm.edit"
									dnd-type="subitem.type"
									dnd-selected="vm.models[vm.materialIndex].selected = subitem"
									ng-class="{'active': vm.models[vm.materialIndex].selected === subitem, 'hidden-chapter': subitem.isVisible === false}"
                                    ng-click="vm.setChapter(subitem)"
                                    subitem
								>
                                    <!-- CHAPTER IN SECTION -->
									<a class="material-editor-02__toc-item-title"
                                        ng-if="!subitem.edit || subitem.edit !== true"
                                        ng-class="{'active': vm.models[vm.materialIndex].selected === subitem,
                                            'error': subitem.status === 'error',
                                            'muted': subitem.isVisible === false}">
                                        {{ subitem.name }}
                                    </a>
									<input ng-model="subitem.name" type="text" ng-if="subitem.edit === true" class="form-control menu-item-edit-input"/>
									<button class="btn ico-check success" ng-if="subitem.edit === true" ng-click="subitem.edit=false; vm.edit=false;"/>

									<div class="material-editor-02__action-menu action-menu" ng-if="!subitem.edit || subitem.edit !== true">
										<button aria-haspopup="true" aria-expanded="{{subitem.actions}}"
                                            ng-click="vm.actions=false;vm.closeMenus(subitem); subitem.actions=!subitem.actions; vm.showItemMenu($event);">
                                            <span>{{ 'filter.Actions' | translate }}</span>
                                        </button>
										<ul role="action-menu">
											<li><a ng-click="vm.actions=false;vm.closeMenus(); subitem.edit=true; vm.edit=true">{{ 'general.Edit' | translate }}</a></li>
											<li><a ng-click="vm.toggleChapterVisibility(subitem)">
												{{ subitem.isVisible === false
													? ('authoringTool.Show chapter' | translate)
													: ('authoringTool.Hide chapter' | translate) }}
											</a></li>
											<li><a ng-click="vm.setChapterVisibilityInAllLanguages(subitem, true)">
												{{ 'authoringTool.Make this chapter visible in all languages' | translate }}
											</a></li>
											<li><a ng-click="vm.setChapterVisibilityInAllLanguages(subitem, false)">
												{{ 'authoringTool.Hide this chapter in all languages' | translate }}
											</a></li>
											<li><a ng-click="vm.exportChapter(subitem)">
												{{ 'authoringTool.Export to another language' | translate }}
											</a></li>
											<li><a ng-click="vm.deleteChapter(subitem)">{{ 'general.Delete' | translate }}</a></li>
										</ul>
									</div>
								</li>
							</ul>
						</li>
					</ul>

					<div ng-if="!vm.models[vm.materialIndex].list.length" class="material-editor-02__intro">
						<div class="alert alert-plain"><p class="">{{ 'general.There\\'s nothing here yet' | translate }}</p></div>
						<button class="btn bordered02 w100p ico-chapter mt1em" ng-click="vm.addChapter()">{{ 'authoringTool.Add chapter' | translate }}</button>
						<p class="desc muted mt10">{{ 'authoringTool.Chapter is a structured segment of a course that focuses on a specific topic' | translate }}</p>
						<button class="btn bordered02 w100p ico-section-empty mt30" ng-click="vm.addSection()">{{ 'authoringTool.Add section' | translate }}</button>
						<p class="desc muted mt10">{{ 'authoringTool.Section groups similar chapters' | translate }}</p>
					</div>
                    <div class="alert alert-warn" ng-if="vm.errors.length" style="margin:0">
                        <ul>
                            <li ng-repeat="error in vm.errors track by $index + error">{{ error }}</li>
                        </ul>
                    </div>
				</div>
				<div class="material-editor-02__action-menu add-chapter-menu action-menu">
					<button style="padding-left: 50px" aria-haspopup="true" class="visible-label btn bordered02 ico-plus" aria-expanded="{{vm.actions}}"
                        ng-click="vm.closeMenus(); vm.actions=!vm.actions; vm.showActivityMenu($event);">{{ 'authoringTool.Add content' | translate }}</button>
					<ul role="action-menu" style="left: 20px;">
                        <li><a ng-click="vm.addChapter(); vm.actions=false;">{{ 'authoringTool.Chapter' | translate }}</a></li>
						<li><a ng-click="vm.addSection(); vm.actions=false;">{{ 'authoringTool.Section' | translate }}</a></li>
					</ul>
				</div>
			</nav>
            <div ng-if="vm.settings===true" class="material-editor-02__settings">
                <h2 class="material-editor-02__settings-title">{{ 'authoringTool.General settings' | translate }}</h2>
                <button class="material-editor-02__settings-close" ng-click="vm.closeSettings()">{{ 'general.Close' | translate }}</button>
                <div class="material-editor-02__settings-inner">
                    <div class="form">
                        <div class="row">
                            <label class="label">{{ 'authoringTool.Chapter navigation' | translate }}</label>
                            <div class="items">
                                <select class="form-control" ng-model="vm.chapterNavigation">
                                    <option value="free">{{ 'course.Any' | translate }}</option>
                                    <option value="linear">{{ 'course.Sequence' | translate }}</option>
                                </select>
                                <p class="desc" ng-if="vm.chapterNavigation==='free'">{{ 'authoringTool.Chapters can be completed in any order' | translate }}</p>
                                <p class="desc" ng-if="vm.chapterNavigation==='linear'">{{ 'authoringTool.Chapters need to be completed in set order' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="material-editor__content">
                <span
                    ng-repeat="chapter in vm.getChapters()"
                    ng-show="vm.models[vm.materialIndex].selected && chapter.uniqueKey === vm.models[vm.materialIndex].selected.uniqueKey"
                    ng-if="vm.chapterUniqueKeysForGeneratedTinyMce.includes(chapter.uniqueKey)"
                >
                    <courses-authoring-tool-material
                        chapter-form="chapter"
                        material="vm.material"
                    ></courses-authoring-tool-chapter>
                </span>

                <div class="material-editor-02__nocontent" ng-if="!vm.models[vm.materialIndex].list.length">
                    <p>{{ vm.dynamicTranslations.hello }}!<br/>
                        {{ vm.dynamicTranslations.startNewLanguage }}</p>
                </div>
            </div>

		</div>
	</div>
</div>
<style>
    .material-editor__content {
        padding: 0
    }
    .click-outside-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 49; /* below your menu */
        background: transparent;
    }
    /* the wrappers down to the editor are flex columns, so the editor fills the space left under the header */
    .material-editor__content > span,
    .material-editor__content courses-authoring-tool-material,
    .material-editor__content tinymce,
    .material-editor__content tinymce > div:not(.hidden),
    .material-editor__content tinymce > div > div {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }
    /* a zero flex basis makes the inline height TinyMCE sets on the editor irrelevant */
    .material-editor__content .tox-tinymce {
        flex: 1 1 0;
        border: none;
    }
    .material-editor__content .tox .tox-statusbar {
        display: none;
    }
    .material-editor {
        min-height: calc(100vh - 64px);
    }
    .material-editor-02__action-menu.add-chapter-menu {
        margin: 0 -20px 5px!important;
    }
    .material-editor-02__action-menu.add-chapter-menu BUTTON {
        padding-top:12px;
    }
    .material-editor-02__action-menu.add-chapter-menu BUTTON.visible-label[class*=" ico"]::before {
        padding-top:22px;
        font-weight: 800;
        font-size: 12px !important;
        padding-left: 10px;
    }
    #toast-container {
        top: auto !important;
        bottom: 12px !important;
        right: 12px !important;
        left: auto !important;
    }
    .authoring-tool-white-button:after {
        background: white!important;
    }
    .authoring-tool-white-button:before {
        color:black!important;
    }
    /* Fade the chapter itself, but not the action menu popup, which stays fully readable */
    .hidden-chapter .material-editor-02__toc-item-title,
    .hidden-chapter .material-editor-02__action-menu > BUTTON {
        opacity: 0.45;
    }
    .hidden-chapter .material-editor-02__toc-item-title {
        font-style: italic;
    }
    /* Menus of items near the bottom of the window are opened upwards to stay fully visible */
    .material-editor-02__action-menu.open-up > UL {
        top: auto;
        bottom: 100%;
        margin: 0 0 5px;
    }
</style>
    `
})
export default class {
    constructor (TokenService, CourseTrainingResource, lodash, $rootScope, $scope, $document, toastr, $translate,
        COMPANY_LANGUAGE_ENUM, ModalService, CourseVersionTrainingFormMaterialService
    ) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.TokenService = TokenService;
        this.CourseTrainingResource = CourseTrainingResource;
        this.lodash = lodash;
        this.toastr = toastr;
        this.$translate = $translate;
        this.$document = $document;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.ModalService = ModalService;
        this.MaterialService = CourseVersionTrainingFormMaterialService;

        this.companySupportedLanguages = this.TokenService.getCompanySupportedLanguages();
        this.defaultLanguage = this.TokenService.getCompanyLanguage();

        // for already generated chapters, we will not regenerate tinyMce editor to not waste tokens
        this.chapterUniqueKeysForGeneratedTinyMce = [];

        // Transform unified API format to per-language format before processing
        this.trainingForm.materials = this.MaterialService
            .transformMaterialsFromApi(this.trainingForm.materials);

        // if material for specific language doesn't exist, we add language with flag isEnabled = false
        this.addDefaultMaterials();

        // we need select first enabled, only then default
        if (!this.selectedLanguage) {
            this.selectedLanguage = this.getDefaultSelectedLanguage();
        }

        $scope.$on('authoringTool:toEditor', () => {
            if (this.isEditorViewGenerated) {
                this.viewMode = 'editor';
                return;
            }

            this.uibModalInstance.close();
        });

        this.models = [];

        this.setMaterial();
        this.convertMaterialsToModels();
        this.initSettings();
        this.setActiveChapter();

        this.initMode(this.viewMode);

        this.handleOutsideMenusClicks();
        this.handleSettingsPanelClosing();

        // to be sure models data is generated
        setTimeout(() => {
            this.initialStateHash = this.getStateHash();
        }, 200);

        this.setDynamicTranslations(this.selectedLanguage);

        this.closeModal = this.closeModal.bind(this);
        this.initMode = this.initMode.bind(this);
    }

    setDynamicTranslations (lang) {
        this.$translate.use(lang.toLowerCase()).then(() => {
            this.dynamicTranslations = {
                hello: this.$translate.instant('general.Hello'),
                startNewLanguage: this.$translate.instant('authoringTool.To start with a new language, make a choice on the left')
            };
            this.$translate.use(this.TokenService.getActiveLanguage());
        });
    }

    initMode (mode) {
        this.previewLoading = true;

        if (mode === 'editor') {
            this.isEditorViewGenerated = true;
            this.previewLoading = false;
            this.viewMode = mode;
            return;
        }

        if (mode === 'preview') {
            const selected = this.models[this.materialIndex] ? this.models[this.materialIndex].selected : null;

            // we add timeout only when we change from editor to preview
            // to be sure content from inyMce is updated
            if (this.isEditorViewGenerated) {
                setTimeout(() => {
                    this.$scope.$apply(() => {
                        this.previewMaterial = this.buildPreviewMaterial(selected);
                        this.previewLoading = false;
                        this.viewMode = mode;
                    });
                }, 300);

                return;
            }
            this.previewMaterial = this.buildPreviewMaterial(selected);
            this.previewLoading = false;
            this.viewMode = mode;
        }
    }

    /**
     * Builds the material shown in the preview. Hidden chapters are only meant for the
     * editor, so they are left out of the preview.
     */
    buildPreviewMaterial (selected) {
        const material = this.lodash.cloneDeep(this.trainingForm.materials[this.materialIndex]);
        const model = this.lodash.cloneDeep(this.models[this.materialIndex]);
        const previewMaterial = this.addDataFromModelToMaterial(model, material);

        previewMaterial.chapters = this.lodash.filter(previewMaterial.chapters, chapter => chapter.isVisible !== false);

        if (selected) {
            const initialChapter = previewMaterial.chapters.findIndex(chapter => chapter.uniqueKey === selected.uniqueKey);
            previewMaterial.initialChapter = initialChapter === -1 ? 0 : initialChapter;
        }

        return previewMaterial;
    }

    removeMenuEditMode () {
        this.edit = false;
        this.lodash.forEach(this.models[this.materialIndex].list, item => {
            item.edit = false;
            if (item.type === 'section') {
                this.lodash.forEach(item.items, subitem => {
                    subitem.edit = false;
                });
            }
        });
    }

    closeMenus (exceptionItem = null) {
        this.lodash.forEach(this.models[this.materialIndex].list, item => {
            if (exceptionItem && exceptionItem.$$hashKey === item.$$hashKey && item.actions === true) {
                item.actions = true;
            }
            else {
                item.actions = false;
            }
            if (item.type === 'section') {
                this.lodash.forEach(item.items, subitem => {
                    if (exceptionItem && exceptionItem.$$hashKey === subitem.$$hashKey && subitem.actions === true) {
                        subitem.actions = true;
                    }
                    else {
                        subitem.actions = false;
                    }
                });
            }
        });
    }

    /**
     * The action menu opens downwards by default, which hides it when the item is near the bottom
     * of the window. In that case the menu is flipped above the button.
     */
    showItemMenu (event) {
        const menu = event.currentTarget.closest('.material-editor-02__action-menu');
        if (!menu) {
            return;
        }

        menu.classList.remove('open-up');

        setTimeout(() => {
            const list = menu.querySelector('UL');
            if (!list) {
                return;
            }

            const listRect = list.getBoundingClientRect();
            const buttonRect = menu.getBoundingClientRect();
            const spaceBelow = window.innerHeight - buttonRect.bottom;

            if (listRect.height > spaceBelow && buttonRect.top > listRect.height) {
                menu.classList.add('open-up');
            }
        });
    }

    getChapters () {
        const chapters = [];
        const model = this.models[this.materialIndex];
        if (!model) {
            return chapters;
        }
        this.lodash.forEach(model.list, item => {
            if (item.type === 'chapter') {
                chapters.push(item);
            }
            else {
                this.lodash.forEach(item.items, subitem => {
                    chapters.push(subitem);
                });
            }
        });
        return chapters;
    }

    setChapter (chapter) {
        const model = this.models[this.materialIndex];
        if (!model) {
            return;
        }
        model.selected = chapter;
        this.chapterUniqueKeysForGeneratedTinyMce.push(chapter.uniqueKey);
    }

    initItem (item, type) {
        if (item.uniqueKey === undefined) {
            item.uniqueKey = this.getUniqueKey();
        }
        item.type = type;
        item.status = 'ok';
        item.actions = false;
        item.effect = 'move';
        item.edit = false;

        if (type === 'section') {
            item.items = [];
            item.allowedTypes = ['chapter'];
            item.$$hashKey = this.getUniqueKey();
        }

        if (type === 'chapter') {
            if (item.isVisible === undefined) {
                item.isVisible = true;
            }
            // convert chapter's section to sectionData to be able to save later correctly
            // eslint-disable-next-line eqeqeq
            if (item.section != null) {
                item.sectionData = item.section;
                if (item.sectionData.id) {
                    item.sectionData.uniqueKey = item.section.id;
                }
                // eslint-disable-next-line eqeqeq
                if (item.sectionData.uniqueKey == null) {
                    item.sectionData.uniqueKey = this.getUniqueKey();
                }
                delete item.section;
                delete item.sectionId;
            }
        }

        return item;
    }

    /**
     * models structure:
     * this.models = [
     *      list: [
     *          {
     *              type: 'section',
     *              name: 'section name',
     *              items: [
     *                  {
     *                      type: 'chapter,
     *                      name: 'chapter with section'
     *                  }
     *              ]
     *          },
     *          {
     *              type: 'chapter
     *              name: 'chapter without section'
     *          }
     *      ]
     * ]
     */
    convertMaterialsToModels () {
        // the chapter structure is language neutral, so the same chapter has to carry the
        // same uniqueKey in every language, otherwise structural changes (like deleting a
        // chapter) would only be applied to the language that is currently open
        const uniqueKeysByHash = {};

        // set initial models
        this.lodash.forEach(this.trainingForm.materials, (material, index) => {
            const sections = [];

            if (this.models[index] === undefined) {
                this.models[index] = {
                    list: []
                };
            }
            this.models[index].isEnabled = material.isEnabled;
            this.lodash.forEach(material.chapters, chapter => {
                let modelChapter = this.lodash.clone(chapter);
                if (modelChapter.hash && modelChapter.uniqueKey === undefined) {
                    if (uniqueKeysByHash[modelChapter.hash] === undefined) {
                        uniqueKeysByHash[modelChapter.hash] = this.getUniqueKey();
                    }
                    modelChapter.uniqueKey = uniqueKeysByHash[modelChapter.hash];
                }
                // add needed initial properties
                modelChapter = this.initItem(modelChapter, 'chapter');

                // chapter with section
                if (modelChapter.sectionData !== undefined) {
                    let section = sections.find(item => item.uniqueKey === modelChapter.sectionData.uniqueKey);
                    if (section === undefined) {
                        section = this.lodash.clone(modelChapter.sectionData);
                        delete modelChapter.sectionData;
                        section = this.initItem(section, 'section');
                        sections.push(section);
                        this.models[index].list.push(section);
                    }
                    section.items.push(this.lodash.clone(modelChapter));
                }
                // chapter without section
                else {
                    this.models[index].list.push(modelChapter);
                }
            });
        });
    }

    toggleSettings () {
        if (this.settings) {
            this.closeSettings();
            return;
        }
        this.settings = true;
        this.toggleEditorsClickListener(true);
    }

    closeSettings () {
        this.settings = false;
        this.toggleEditorsClickListener(false);
    }

    /**
     * Content editors live in iframes, so their clicks never reach the document listener.
     * Each TinyMCE instance is listened directly while the settings panel is open.
     */
    toggleEditorsClickListener (isListening) {
        if (!window.tinymce) {
            return;
        }
        window.tinymce.get().forEach((editor) => {
            if (isListening) {
                editor.on('mousedown', this.editorClickHandler);
            }
            else {
                editor.off('mousedown', this.editorClickHandler);
            }
        });
    }

    handleSettingsPanelClosing () {
        this.editorClickHandler = () => this.$scope.$evalAsync(() => this.closeSettings());

        const outsideClickHandler = (event) => {
            const target = event.target;
            if (!this.settings || !document.contains(target)) {
                return;
            }
            // the toggle button handles opening and closing by itself
            if (target.closest('.material-editor-02__settings, .material-editor-02__settings-toggle')) {
                return;
            }
            this.$scope.$evalAsync(() => this.closeSettings());
        };

        const escapeKeyHandler = (event) => {
            if (!this.settings || event.key !== 'Escape') {
                return;
            }
            // listened in capture phase and default prevented, so the uib modal is not dismissed as well
            event.preventDefault();
            event.stopPropagation();
            this.$scope.$apply(() => this.closeSettings());
        };

        // capture phase, as several elements (drag and drop list, editor toolbar) stop click propagation
        document.addEventListener('click', outsideClickHandler, true);
        document.addEventListener('keydown', escapeKeyHandler, true);

        this.$scope.$on('$destroy', () => {
            this.toggleEditorsClickListener(false);
            document.removeEventListener('click', outsideClickHandler, true);
            document.removeEventListener('keydown', escapeKeyHandler, true);
        });
    }

    initSettings () {
        // settings are shared across all language materials of the same content
        const material = this.lodash.find(this.trainingForm.materials, m => m.settings && m.settings.chapterNavigation);
        this.chapterNavigation = material ? material.settings.chapterNavigation : 'free';
    }

    convertModelsToMaterials () {
        this.lodash.forEach(this.models, (model, materialIndex) => {
            this.trainingForm.materials[materialIndex] = this.addDataFromModelToMaterial(model, this.trainingForm.materials[materialIndex]);
        });
    }

    addDataFromModelToMaterial (model, material) {
        let chapterSequence = 0;
        const chapters = [];
        this.lodash.forEach(model.list, item => {
            if (item.type === 'section') {
                this.lodash.forEach(item.items, chapter => {
                    chapter.sequence = chapterSequence++;
                    chapter.sectionData = {
                        id: item.id,
                        uniqueKey: item.uniqueKey,
                        name: item.name
                    };
                    chapter.section = chapter.sectionData;
                    chapter.isVisible = chapter.isVisible !== false;
                    chapters.push(chapter);
                });
            }
            if (item.type === 'chapter') {
                item.sequence = chapterSequence++;
                item.isVisible = item.isVisible !== false;

                delete item.sectionData;
                delete item.section;
                delete item.sectionId;

                chapters.push(item);
            }
        });
        // Strip trailing blank lines before previewing/saving so they don't accumulate
        // across Preview/Edit cycles (the editor keeps one for typing; it's dropped here).
        this.lodash.forEach(chapters, chapter => {
            if (chapter.content) {
                chapter.content = stripTrailingEmptyParagraphs(chapter.content);
            }
        });

        material.isEnabled = model.isEnabled;
        material.chapters = chapters;
        material.settings = { chapterNavigation: this.chapterNavigation };

        return material;
    }

    changeLanguage () {
        this.setMaterial();
        this.setActiveChapter();
        this.setDynamicTranslations(this.selectedLanguage);
    }

    addDefaultMaterials () {
        if (this.trainingForm.materials === undefined) {
            this.trainingForm.materials = [];
        }
        this.lodash.forEach(this.companySupportedLanguages, lang => {
            const material = this.trainingForm.materials.find(m => m.lang === lang);
            if (!material) {
                this.addMaterial(lang, false);
            }
        });
    }

    addMaterial (lang, isEnabled) {
        const material = {
            trainingId: this.trainingForm.id,
            isEnabled,
            lang,
            chapters: []
        };
        this.trainingForm.materials.push(material);
    }

    addSection () {
        this.setMaterial();

        const sectionName = this.$translate.instant('authoringTool.New section');
        const uniqueKey = this.getUniqueKey();

        this.lodash.forEach(this.models, (model) => {
            if (model === undefined) {
                return;
            }
            let section = {
                name: sectionName,
                uniqueKey
            };
            section = this.initItem(section, 'section');
            model.list.push(section);
        });

        this.toastr.success(this.$translate.instant('authoringTool.Section added into all languages'));
    }

    makeHash () {
        const length = 64;
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }

    toggleChapterVisibility (chapter) {
        chapter.isVisible = !chapter.isVisible;
        this.closeMenus();
        this.actions = false;
    }

    /**
     * Applies the given visibility of the chapter to every language of the material, so the
     * chapter does not have to be shown or hidden language by language.
     */
    setChapterVisibilityInAllLanguages (chapter, isVisible) {
        this.lodash.forEach(this.models, (model) => {
            if (model === undefined) {
                return;
            }
            this.lodash.forEach(model.list, item => {
                if (item === undefined) {
                    return;
                }
                if (item.type === 'chapter' && this.isSameChapter(item, chapter)) {
                    item.isVisible = isVisible;
                }
                else if (item.type === 'section') {
                    this.lodash.forEach(item.items, subitem => {
                        if (subitem !== undefined && this.isSameChapter(subitem, chapter)) {
                            subitem.isVisible = isVisible;
                        }
                    });
                }
            });
        });

        this.closeMenus();
        this.actions = false;
    }

    /**
     * Sections themselves are not hideable, hiding or showing a section means applying the
     * visibility to all of its chapters, in every language.
     */
    setSectionChaptersVisibility (section, isVisible) {
        this.lodash.forEach(section.items, chapter => {
            this.setChapterVisibilityInAllLanguages(chapter, isVisible);
        });

        this.closeMenus();
        this.actions = false;
    }

    /**
     * Lets the user copy the content of the chapter to the same chapter of other languages, so
     * translating can be started from the already written content instead of an empty chapter.
     */
    exportChapter (chapter) {
        this.closeMenus();
        this.actions = false;

        const languages = this.lodash.reduce(this.trainingForm.materials, (result, material, index) => {
            if (material.lang !== this.selectedLanguage && this.models[index] !== undefined) {
                result.push({
                    lang: material.lang,
                    label: this.COMPANY_LANGUAGE_ENUM.LABELS[material.lang],
                    selected: false
                });
            }
            return result;
        }, []);

        if (!languages.length) {
            return;
        }

        this.openExportChapterModal(chapter, languages);
    }

    /**
     * The language selection is reopened with the previous selections whenever the user decides
     * not to overwrite the existing content, so the selection can be corrected.
     */
    openExportChapterModal (chapter, languages) {
        this.ModalService.open({
            size: 'medium',
            template: `
                <modals-courses-authoring-tool-export-chapter
                    languages="vm.languages"
                    ok="vm.$uibModalInstance.close()"
                    cancel="vm.$uibModalInstance.dismiss()"></modals-courses-authoring-tool-export-chapter>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.languages = languages;
            }
        }).then(() => {
            const selectedLanguages = this.lodash.filter(languages, { selected: true });
            const languagesWithContent = this.lodash.filter(selectedLanguages, language => {
                return this.hasChapterContentInLanguage(chapter, language.lang);
            });

            if (!languagesWithContent.length) {
                this.copyChapterToLanguages(chapter, selectedLanguages);
                return;
            }

            const message = this.$translate.instant(
                'authoringTool.The following language(s) already have content in this chapter, are you sure you want to overwrite them? {languages}',
                { languages: this.lodash.map(languagesWithContent, 'label').join(', ') }
            );

            this.ModalService.confirm(message, 'medium')
                .then(() => {
                    this.copyChapterToLanguages(chapter, selectedLanguages);
                })
                .catch(() => {
                    this.openExportChapterModal(chapter, languages);
                });
        }).catch(() => {
            // user canceled — do nothing
        });
    }

    /**
     * Exporting overwrites the content of the target chapter, so the languages that would lose
     * their existing content have to be found before copying.
     */
    hasChapterContentInLanguage (chapter, lang) {
        const modelIndex = this.trainingForm.materials.findIndex(material => material.lang === lang);
        const model = this.models[modelIndex];
        if (model === undefined || !chapter.hash) {
            return false;
        }

        const targetChapter = this.collectChaptersByHash(model)[chapter.hash];
        return Boolean(targetChapter && targetChapter.content);
    }

    /**
     * The uploaded files and images are part of the chapter content, so copying the name and the
     * content is enough to have the whole chapter in the target language.
     */
    copyChapterToLanguages (chapter, languages) {
        this.lodash.forEach(languages, language => {
            const modelIndex = this.trainingForm.materials.findIndex(material => material.lang === language.lang);
            const model = this.models[modelIndex];
            if (model === undefined) {
                return;
            }

            const targetChapter = this.collectChaptersByHash(model)[chapter.hash];
            if (!targetChapter) {
                return;
            }

            targetChapter.name = chapter.name;
            targetChapter.content = chapter.content;

            this.toastr.success(this.$translate.instant(
                'authoringTool.Chapter content was copied to {language}',
                { language: language.label }
            ));
        });
    }

    deleteSection (section) {
        const performDelete = () => {
            this.lodash.forEach(this.models, (m) => {
                if (m === undefined) {
                    return;
                }
                this.lodash.remove(m.list, item => item.uniqueKey === section.uniqueKey);
            });
            this.setActiveChapter();
        };

        if (!this.hasSectionContentInAnyLanguage(section)) {
            performDelete();
        }
        else {
            const message = this.$translate.instant(
                'authoringTool.Section will be removed along with all its chapters and their translations. Are you sure you want to delete the section?'
            );
            this.ModalService.confirm(message, 'medium')
                .then(() => {
                    performDelete();
                })
                .catch(() => {
                    // user canceled — do nothing
                });
        }
    }

    deleteChapter (chapter) {
        const performDelete = () => {
            this.lodash.forEach(this.models, (m) => {
                if (m === undefined) {
                    return;
                }
                this.lodash.remove(m.list, item => item.type === 'chapter' && this.isSameChapter(item, chapter));
                this.lodash.forEach(m.list, item => {
                    if (item !== undefined && item.type === 'section') {
                        this.lodash.remove(item.items, itemToDelete => this.isSameChapter(itemToDelete, chapter));
                    }
                });
            });
            this.setActiveChapter();
        };

        if (!this.hasChapterContentInAnyLanguage(chapter)) {
            performDelete();
        }
        else {
            const message = this.$translate.instant(
                'authoringTool.Chapter will be removed along with all its translations. Are you sure you want to delete the chapter?'
            );
            this.ModalService.confirm(message, 'medium')
                .then(() => {
                    performDelete();
                })
                .catch(() => {
                    // user canceled — do nothing
                });
        }
    }

    /**
     * The content is language specific, so the deletion has to be confirmed whenever any of the
     * translations of the chapter has content, not only the language currently in focus.
     */
    hasChapterContentInAnyLanguage (chapter) {
        if (!chapter.hash) {
            return Boolean(chapter.content);
        }

        return this.lodash.some(this.models, model => {
            if (model === undefined) {
                return false;
            }
            const chapterOfLanguage = this.collectChaptersByHash(model)[chapter.hash];
            return Boolean(chapterOfLanguage && chapterOfLanguage.content);
        });
    }

    /**
     * A section is deleted along with its chapters, so the confirmation is needed whenever any
     * chapter of the section has content in any of the languages.
     */
    hasSectionContentInAnyLanguage (section) {
        return this.lodash.some(section.items, chapter => this.hasChapterContentInAnyLanguage(chapter));
    }

    /**
     * Chapters are language neutral and identified by their hash, the uniqueKey is only a
     * fallback for chapters that have not been given a hash yet.
     */
    isSameChapter (chapter, chapterToCompare) {
        if (chapter.hash && chapterToCompare.hash) {
            return chapter.hash === chapterToCompare.hash;
        }
        return chapter.uniqueKey === chapterToCompare.uniqueKey;
    }

    countChaptersInsideModel (model) {
        let count = 0;
        this.lodash.forEach(model.list, item => {
            if (item.type === 'chapter') {
                count ++;
            }
            else {
                this.lodash.forEach(item.items, () => {
                    count ++;
                });
            }
        });
        return count;
    }

    addChapterToSection (section) {
        const chapterName = this.$translate.instant('course.materialSource.Chapter');
        const hash = this.makeHash();
        const chapterNumber = this.countChaptersInsideModel(this.models[this.materialIndex]) + 1;
        const uniqueKey = this.getUniqueKey();

        this.lodash.forEach(this.models, (model, modelIndex) => {
            if (model === undefined) {
                return;
            }
            let chapter = {
                hash,
                name: `${chapterName} ${chapterNumber}`,
                uniqueKey
            };
            chapter = this.initItem(chapter, 'chapter');
            chapter.isVisible = false;

            const targetSection = this.findSectionByUniqueKey(model, section.uniqueKey);
            if (targetSection) {
                targetSection.items.push(chapter);
            }

            if (modelIndex === this.materialIndex) {
                model.selected = chapter;
                this.chapterUniqueKeysForGeneratedTinyMce.push(chapter.uniqueKey);
            }
        });

        this.toastr.success(this.$translate.instant('authoringTool.Chapter added into all languages'));
    }

    addChapter () {
        this.setMaterial();

        const chapterName = this.$translate.instant('course.materialSource.Chapter');
        const hash = this.makeHash();
        const chapterNumber = this.countChaptersInsideModel(this.models[this.materialIndex]) + 1;
        const uniqueKey = this.getUniqueKey();

        this.lodash.forEach(this.models, (model, modelIndex) => {
            if (model === undefined) {
                return;
            }
            let chapter = {
                hash,
                name: `${chapterName} ${chapterNumber}`,
                uniqueKey
            };
            chapter = this.initItem(chapter, 'chapter');
            chapter.isVisible = false;
            model.list.push(chapter);

            if (modelIndex === this.materialIndex) {
                model.selected = chapter;
                this.chapterUniqueKeysForGeneratedTinyMce.push(chapter.uniqueKey);
            }
        });

        this.toastr.success(this.$translate.instant('authoringTool.Chapter added into all languages'));
    }

    findSectionByUniqueKey (model, uniqueKey) {
        return model.list.find(item => item.type === 'section' && item.uniqueKey === uniqueKey);
    }

    onChapterMoved (sourceList, index) {
        sourceList.splice(index, 1);
        this.syncStructureAcrossLanguages();
    }

    syncStructureAcrossLanguages () {
        const activeModel = this.models[this.materialIndex];

        this.lodash.forEach(this.models, (model, modelIndex) => {
            if (modelIndex === this.materialIndex) {
                return;
            }

            // the chapters have to be collected up front: rebuilding the list empties the sections
            // and a chapter moved out of a section but placed after it would no longer be findable
            const chaptersByHash = this.collectChaptersByHash(model);

            const newList = [];
            this.lodash.forEach(activeModel.list, (activeItem) => {
                if (activeItem.type === 'chapter') {
                    const chapter = chaptersByHash[activeItem.hash];
                    if (chapter) {
                        newList.push(chapter);
                    }
                }
                else if (activeItem.type === 'section') {
                    let section = this.findSectionByUniqueKey(model, activeItem.uniqueKey);
                    if (!section) {
                        section = this.lodash.clone(activeItem);
                        section.items = [];
                        section = this.initItem(section, 'section');
                    }
                    const newItems = [];
                    this.lodash.forEach(activeItem.items, (activeChapter) => {
                        const chapter = chaptersByHash[activeChapter.hash];
                        if (chapter) {
                            newItems.push(chapter);
                        }
                    });
                    section.items = newItems;
                    newList.push(section);
                }
            });
            model.list = newList;
        });
    }

    collectChaptersByHash (model) {
        const chaptersByHash = {};

        this.lodash.forEach(model.list, (item) => {
            if (item.type === 'chapter') {
                chaptersByHash[item.hash] = item;
            }
            else if (item.type === 'section') {
                this.lodash.forEach(item.items, (chapter) => {
                    chaptersByHash[chapter.hash] = chapter;
                });
            }
        });

        return chaptersByHash;
    }

    handleOutsideMenusClicks () {
        // handle closing menu dropdowns
        const documentClickHandler = (event) => {
            if (!event.target.closest('.material-editor-02__action-menu')) {
                this.closeMenus();
                this.actions = false;
            }
        };

        this.$document.on('click', documentClickHandler);

        // handle closing menu edit mode
        document.addEventListener('mousedown', (event) => {
            const clickedElement = event.target;
            if (!clickedElement.classList.contains('menu-item-edit-input')) {
                this.removeMenuEditMode();
            }
        });
    }

    setActiveChapter () {
        const model = this.models[this.materialIndex];
        for (let i = 0; i < model.list.length; i++) {
            const item = model.list[i];
            if (item.type === 'section') {
                for (let j = 0; j < item.items.length; j++) {
                    const chapter = item.items[j];
                    model.selected = chapter;
                    this.chapterUniqueKeysForGeneratedTinyMce.push(chapter.uniqueKey);
                    return;
                }
            }
            model.selected = item;
            this.chapterUniqueKeysForGeneratedTinyMce.push(item.uniqueKey);
            return;
        }
    }

    getDefaultSelectedLanguage () {
        let language = this.defaultLanguage;
        const material = this.lodash.find(this.trainingForm.materials, { isEnabled: true });
        if (material) {
            language = material.lang;
        }
        return language;
    }

    isLanguageEnabled (lang) {
        const materialIndex = this.trainingForm.materials.findIndex(m => m.lang === lang);
        return this.models[materialIndex] !== undefined ? this.models[materialIndex].isEnabled : false;
    }

    toggleLanguage (lang) {
        const materialIndex = this.trainingForm.materials.findIndex(m => m.lang === lang);
        this.models[materialIndex].isEnabled = !this.models[materialIndex].isEnabled;
    }

    setMaterial () {
        this.materialIndex = this.trainingForm.materials.findIndex(m => m.lang === this.selectedLanguage);
        // this.material = this.trainingForm.materials[this.materialIndex];

        if (this.models[this.materialIndex] === undefined) {
            this.models[this.materialIndex] = {
                list: []
            };
        }
    }

    getUniqueKey () {
        return new Date().getTime() + Math.random();
    }

    /**
     * The settings are not part of the models, they are added so that changing only a setting counts as unsaved
     */
    getStateHash () {
        return JSON.stringify({
            models: this.models,
            chapterNavigation: this.chapterNavigation
        });
    }

    closeModal () {
        const confirmMessage = this.$translate.instant('general.Latest changes have not been saved. Do you want to proceed editing to save changes?');

        // wait until content from tinyMce will be updated
        setTimeout(() => {
            const stateHash = this.getStateHash();

            if (this.initialStateHash === stateHash) {
                this.$rootScope.$broadcast('material:init');
                this.uibModalInstance.close();
            }
            else {
                this.ModalService.confirm(confirmMessage, 'medium')
                .catch((action) => {
                    if (action === 'no') {
                        this.$rootScope.$broadcast('material:init');
                        this.uibModalInstance.close();
                    }
                });
            }
        }, 200);
    }

    save () {
        this.errors = [];
        this.editorLoading = true;
        this.convertModelsToMaterials();

        // wait until content from tinyMce will be updated
        setTimeout(() => {
            if (this.context === 'edit') {
                this.CourseTrainingResource.updateMaterials({ id: this.trainingForm.id, expand:
                    'chapters.chapterI18ns,chapters.section.sectionI18ns,languages'
                 }, { materials: this.trainingForm.materials }).$promise
                    .then(response => {
                        delete response.$promise;
                        delete response.$resolved;

                        this.toastr.success(this.$translate.instant('general.Changes saved'));

                        // the models of the editor are kept, so the materials have to stay
                        // in the same language order as they were before the save
                        const languageOrder = this.lodash.map(this.trainingForm.materials, 'lang');

                        this.trainingForm.materials = this.MaterialService.sortMaterialsByLanguages(
                            this.MaterialService.transformMaterialsFromApi([response]),
                            languageOrder
                        );
                        this.addDefaultMaterials();
                    }).catch((response) => {
                        this.toastr.error(this.$translate.instant('general.There were errors processing the form'));
                        response.data.forEach((error) => {
                            this.errors.push(error.message);
                        });
                    }).finally(() => {
                        this.initialStateHash = this.getStateHash();
                        this.editorLoading = false;
                    });
            }
            else {
                this.initialStateHash = this.getStateHash();
                this.editorLoading = false;
            }
        }, 200);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/index.js